import {
  IconCalendar,
  IconChevronLeft,
  IconChevronRight,
  IconEye,
  IconReload,
  IconTrash,
  IconSearch,
  IconX,
} from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailTransaksiPembelian from './DetailTransaksiPembelian';
import { Tooltip } from 'antd';
import ConfirmationTransferModal from './ConfirmationTransferModal';
import moment from 'moment';
import Input from '../../components/Input';
import EditTrxPembelian from './EditTrxPembelian';
import { IconPhotoEdit } from '@tabler/icons-react';
import ConfirmationDeletePembelian from '../../components/Admin/ConfirmationDeletePembelian';
import LoadingIndicator from '../../components/LoadingIndicator';
import { useMasterData } from '../../context/MasterDataContext';
import FilterDrawer, { FilterToggleButton, KaratGridFilter } from '../../components/FilterDrawer';

const TrxPembelianV2 = () => {
  const navigate = useNavigate();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { kategoriList: kategori = [], cabangList = [] } = useMasterData() || {};

  const selectCabang = React.useMemo(() => {
    return (cabangList || []).filter(
      (cb) => Number(cb.is_toko) === 1 || cb.is_toko === true || !cb.nama_cabang?.toLowerCase().includes('brankas')
    );
  }, [cabangList]);

  const [submitPembelian, setSubmitPembelian] = useState(false);
  const [isSubmitEdit, setIsSubmitEdit] = useState(false);

  const [trxPembelian, setTrxPembelian] = useState([]);
  const [detailPembelian, setDetailPembelian] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pembelian_id, setIdTrxPembelian] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);

  const [show, setShow] = useState(false);
  const [submitChange, setSubmitChange] = useState(false);
  const [activeTab, setActiveTab] = useState('Transaksi Pembelian');
  let [isOpen, setIsOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState('');

  // FILTER STATE
  const [idCabang, setIdCabang] = useState(0);
  const [openCalender, setOpenCalender] = useState(false);
  const [kodeTransaksi, setKodeTransaksi] = useState('');

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [perPage, setPerPage] = useState(10);
  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [deleteId, setDeleteId] = useState('');
  const [openLoading, setOpenLoading] = useState(false);
  const [loadingDel, setLoadingDel] = useState(false);
  const [pembelianDelete, setPembelianDelete] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  let [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const [selectedKarat, setSelectedKarat] = useState('');

  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [reloadTrigger, setReloadTrigger] = useState(0);

  const activeFilterCount = [
    idCabang && idCabang !== '0',
    selectedKategori,
    selectJenisKategori,
    selectedKarat,
    filterBerat,
  ].filter(Boolean).length;

  const handleResetAndReload = () => {
    setSearch('');
    setIdCabang(0);
    setStartDate(new Date());
    setEndDate(new Date());
    setSelectedKarat('');
    setFilterBerat('');
    setSelectedKategori('');
    setSelectJenisKategori('');
    setCurrentPage(1);
    setPageInput('1');
    setReloadTrigger(prev => prev + 1);
  };

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
    setCurrentPage(1);
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
    setCurrentPage(1);
  };

  const filterBeratBarang = () => {
    setFilterBerat(filterBerat);
    setCurrentPage(1);
  };

  function closeModalDelete() {
    setIsOpenModalDelete(false);
  }

  function openModalDelete() {
    setIsOpenModalDelete(true);
  }

  function numberWithCommas(x) {
    if (x === undefined || x === null) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  async function getTrxPembelian() {
    setLoading(true);
    const params = new URLSearchParams();
    if (search !== '') {
      params.append('faktur', search);
    } else {
      params.append('page', currentPage);
    }
    params.append('per_page', perPage);
    if (idCabang && idCabang !== 0 && idCabang !== '0') params.append('cabang', idCabang);
    if (selectedKategori && selectedKategori !== 0 && selectedKategori !== '0') params.append('kategori', selectedKategori);
    if (selectJenisKategori && selectJenisKategori !== 0 && selectJenisKategori !== '0') params.append('jenis_kategori', selectJenisKategori);
    if (startDate !== null && endDate !== null) {
      params.append('tgl_awal', awal);
      params.append('tgl_akhir', akhir);
    }
    if (selectedKarat) params.append('karat', selectedKarat);
    if (filterBerat) params.append('berat', filterBerat);
    
    if (activeTab === 'Pembelian Return') {
      params.append('is_refund', '1');
    } else {
      params.append('is_refund', '0');
    }

    await http
      .get(`pembelian?${params.toString()}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setLastPage(res.data.data.last_page);
        setCurrentPage(res.data.data.current_page);
        setItemsPerPage(res.data.data.per_page);
        setTrxPembelian(res.data.data.data);
        return res.data.data.data;
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response?.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    getTrxPembelian();
  }, [
    isSubmit === true,
    isSubmitEdit === true,
    idCabang,
    search.length >= 12 ? search : '',
    currentPage,
    startDate,
    endDate,
    awal,
    akhir,
    selectedKarat,
    filterBerat,
    selectedKategori,
    selectJenisKategori,
    reloadTrigger,
    activeTab,
    perPage,
  ]);
  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const jumpToPage = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= lastPage) {
      setCurrentPage(pageNumber);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      jumpToPage();
      e.target.blur();
    }
  };

  function getIdPembelian(trx) {
    setKodeTransaksi(trx.kode_trx);
    setIdTrxPembelian(trx.id);
    setDetailPembelian(trx);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  DinamicTitle('Transaksi Pembelian || Komala Dewi');

  // TRANFER ITEM
  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;
  const [loadingEditPembelian, setLoadingEditPembelian] = useState(false);
  let [isOpenEditTrx, setIsOpenEditTrx] = useState(false);

  function closeModalEditTrx() {
    setIsOpenEditTrx(false);
  }

  function openModalEditTrx() {
    setIsOpenEditTrx(true);
  }
  const [idEdit, setIdEdit] = useState('');
  const [karat, setKarat] = useState('');
  const [kondisi_barang, setKondisiBarang] = useState('');
  const [harga_beli, setHargaBeli] = useState('');
  const [jenis_kategori_id, setJenisKategoriIdBase] = useState('');
  const [is_change_harga, setIsChange] = useState(false);
  const [gambar, setGambar] = useState(null);

  const [idEditPembelian, setIdEditPembelian] = useState([]);
  async function getIdEditPembelian(id) {
    setLoadingEditPembelian(true);
    await http
      .get(`/pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategoriIdBase(res.data.data.jenis_kategori_id);
        setIdEditPembelian(res.data.data);
        setKondisiBarang(res.data.data.kondisi_barang);
        openModalEditTrx();
        setIdEdit(res.data.data.id);
        setBerat(res.data.data.berat);
        setHargaBeli(res.data.data.harga_beli);
        setKarat(res.data.data.karat);
        // setGambar(res.data.data.gambar[0].asli);
        return res.data;
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          toast.warning('Periksa data yang diubah', { autoClose: 600, });
        }
        console.log(err.response);
      });
    setLoadingEditPembelian(false);
  }
  const [isSelected, setIsSelected] = useState(false);
  async function editTrxPembelian(e) {
    e.preventDefault();
    setSubmitPembelian(true);
    setIsSubmitEdit(true);

    try {
      const data = { berat, harga_beli, karat, gambar, jenis_kategori_id, is_change_harga, kondisi_barang };
      const response = await http.put(`pembelian/${idEdit}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message || 'Data berhasil diupdate', { autoClose: 600, });
      closeModalEditTrx();
      setSubmitPembelian(false);
      setIsSelected(false);
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        toast.warning('Waktu permintaan ke server habis', { autoClose: 600, });
      } else {
        console.log(error);
      }
    }
    setTimeout(() => {
      setSubmitPembelian(false);
    }, 1000);
    setTimeout(() => {
      setIsSubmitEdit(false);
    }, 1000);
  }

  async function getIdDelete(id) {
    setLoadingDel(true);
    await http
      .get(`pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        openModalDelete();
        setDeleteId(res.data.data.id);
        setPembelianDelete(res.data.data);
        setLoadingDel(false);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingDel(false);
  }

  async function deletePembelian(alasan = 'Salah input data', keterangan = '') {
    setIsDelete(true);
    await http
      .delete(`pembelian/${deleteId}`, {
        data: { alasan, keterangan },
        params: { alasan, keterangan },
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModalDelete();
        toast.success(res.data.message || 'Berhasil memproses penghapusan pembelian', { autoClose: 1500 });
        getTrxPembelian();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.message || 'Gagal menghapus pembelian');
      })
      .finally(() => {
        setIsDelete(false);
      });
  }

  return (
    <Layouts
      // title={'Transaksi Pembelian'}
      compFilter={null}
    >

      <div className="mt-4 md:mt-0">
        <div className="flex space-x-4 border-b border-slate-200 dark:border-slate-800 mb-2">
          <button
            className={`px-4 py-2 text-sm font-bold transition-colors border-b-2 ${
              activeTab === 'TRX Pembelian'
                ? 'border-amber-500 text-amber-600 dark:text-amber-400'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
            }`}
            onClick={() => {
              setActiveTab('TRX Pembelian');
              setCurrentPage(1);
            }}
          >
            TRX Pembelian
          </button>
          <button
            className={`px-4 py-2 text-sm font-bold transition-colors border-b-2 ${
              activeTab === 'Pembelian Return'
                ? 'border-amber-500 text-amber-600 dark:text-amber-400'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
            }`}
            onClick={() => {
              setActiveTab('Pembelian Return');
              setCurrentPage(1);
            }}
          >
            TRX Return
          </button>
        </div>

        <div className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800">
          <div className="p-3 flex items-center gap-2 justify-between">
            <div className="flex-1 md:flex-none md:w-72">
              <Input
                className="input w-full h-[2.5rem] border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                autoComplete="off"
                placeholder="Masukkan Pembelian (Faktur)"
              />
            </div>
            <div className="flex items-center gap-2">
              <FilterToggleButton
                onClick={() => setIsFilterOpen(true)}
                isOpen={isFilterOpen}
                activeFilterCount={activeFilterCount}
              />
              <button
                type="button"
                onClick={handleResetAndReload}
                className="bg-slate-800 hover:bg-slate-900 text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm flex items-center justify-center flex-shrink-0"
                title="Refresh & Reset Filter"
              >
                <IconReload className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Filter Drawer (muncul dari kanan layar) */}
        <FilterDrawer
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          title="Filter Pembelian"
          subtitle="Filter transaksi pembelian"
          activeFilterCount={activeFilterCount}
          onReset={handleResetAndReload}
        >
          {/* Tanggal */}
          <div className="dropdown dropdown-bottom w-full">
            <div
              tabIndex={0}
              className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs"
              title="Filter Tanggal"
            >
              <div className="flex items-center gap-2 truncate">
                <IconCalendar size={16} className="text-amber-500 shrink-0" />
                <span className="truncate">
                  {startDate && endDate
                    ? awal === akhir
                      ? awal
                      : `${awal} - ${akhir}`
                    : 'Semua Waktu'}
                </span>
              </div>
            </div>
            <div
              tabIndex={0}
              className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] mt-1 right-0 max-w-[92vw] overflow-x-auto"
            >
              <DateRange ranges={[selectionRange]} onChange={handleSelect} />
              {startDate && (
                <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setCurrentPage(1);
                    }}
                    className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                  >
                    Reset Tanggal
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Etalase */}
          <select
            value={idCabang}
            onChange={(e) => {
              setIdCabang(e.target.value);
              setCurrentPage(1);
            }}
            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
          >
            <option value="">Semua Etalase</option>
            {selectCabang.map((cb) => (
              <option value={cb.id} key={cb.id}>
                {cb.nama_cabang}
              </option>
            ))}
          </select>

          {/* Kategori */}
          <select
            value={selectedKategori}
            onChange={handleKategoriChange}
            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs"
          >
            <option value="">Semua Kategori</option>
            {kategori.map((item) => (
              <option key={item.id} value={item.id}>
                {item.nama_kategori}
              </option>
            ))}
          </select>

          {/* Jenis Kategori */}
          <select
            onChange={handleJenisKategoriChange}
            value={selectJenisKategori}
            disabled={!selectedKategori}
            className={`w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 outline-none shadow-xs ${
              !selectedKategori
                ? 'opacity-50 cursor-not-allowed'
                : 'cursor-pointer hover:border-amber-300 dark:hover:border-amber-500'
            }`}
          >
            <option value="">Semua Jenis</option>
            {selectedKategori &&
              kategori
                .find((kt) => kt.id === parseInt(selectedKategori))
                ?.jenis_kategori?.map((jk) => (
                  <option key={jk.id} value={jk.id}>
                    {jk.nama_jenis}
                  </option>
                ))}
          </select>

          {/* Karat */}
          <KaratGridFilter
            selectedKarat={selectedKarat}
            onChange={(val) => {
              setSelectedKarat(val);
              setCurrentPage(1);
            }}
          />

          {/* Berat */}
          <div className="flex items-center gap-1.5">
            <Input
              value={filterBerat}
              onChange={(e) => setFilterBerat(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && filterBeratBarang()}
              placeholder="Cari Berat"
              className="flex-1 h-10 border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-xl transition-colors"
            />
            <button
              type="button"
              onClick={filterBeratBarang}
              className="bg-amber-500 hover:bg-amber-600 text-white h-10 w-10 rounded-xl transition-colors shadow-sm flex items-center justify-center flex-shrink-0"
              title="Terapkan Berat"
            >
              <IconSearch className="w-4 h-4" />
            </button>
          </div>
        </FilterDrawer>

        <div className="dark:border-slate-700/60 pt-2">
          <ConfirmationDeletePembelian
            isDelete={isDelete}
            deletePembelian={deletePembelian}
            pembelianDelete={pembelianDelete}
            isOpenModalDelete={isOpenModalDelete}
            closeModalDelete={closeModalDelete}
          />

          {openLoading || loadingDel ? (
            <LoadingIndicator />
          ) : (
            ''
          )}

          {loadingEditPembelian ? (
            <LoadingIndicator />
          ) : (
            <EditTrxPembelian
              idEditPembelian={idEditPembelian}
              submitPembelian={submitPembelian}
              setJenisKategoriIdBase={setJenisKategoriIdBase}
              setIsChange={setIsChange}
              isSelected={isSelected}
              setIsSelected={setIsSelected}
              gambar={gambar}
              setGambar={setGambar}
              is_change_harga={is_change_harga}
              editTrxPembelian={editTrxPembelian}
              berat={berat}
              karat={karat}
              setKarat={setKarat}
              setKondisiBarang={setKondisiBarang}
              harga_beli={harga_beli}
              setHargaBeli={setHargaBeli}
              setBerat={setBerat}
              isOpenEditTrx={isOpenEditTrx}
              closeModalEditTrx={closeModalEditTrx}
            />
          )}

          {show ? (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
              <div className="w-12 h-12  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
            </div>
          ) : (
            <DetailTransaksiPembelian
              detailPembelian={detailPembelian}
              closeModal={closeModal}
              isOpen={isOpen}
            />
          )}

          <div className="mt-0">
            <div className="block min-w-full shadow-sm sm:rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
              <div className="relative overflow-x-auto scrollbar-thin">
                {loading ? (
                  <div className="flex justify-center py-6 w-full items-center">
                    <div className="w-6 h-6 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent mr-2"></div>
                    <div className="font-semibold text-slate-500 dark:text-slate-400">Loading....</div>
                  </div>
                ) : (
                  <table className="min-w-full leading-normal">
                    <thead>
                      <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          No
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Kode TRX
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Barang
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Nama Etalase
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Kondisi
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Berat | Karat
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Harga
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Rata | Gram
                        </th>
                        <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                          Tanggal
                        </th>
                        {activeTab === 'Pembelian Return' && (
                          <>
                            <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                              Diproses Oleh
                            </th>
                            <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                              Tgl Return
                            </th>
                          </>
                        )}
                        {activeTab !== 'Pembelian Return' && (
                          <th scope="col" className="py-3 px-3 text-center text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                            Aksi
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {trxPembelian.map((trx, i) => (
                        <tr
                          key={trx.id}
                          onClick={() => getIdPembelian(trx)}
                          className="hover:bg-amber-50 dark:hover:bg-slate-800/80 cursor-pointer transition-colors border-b border-slate-100 dark:border-slate-700/50 bg-white dark:bg-slate-900"
                        >
                          <td className="px-3 py-1.5 text-sm">
                            <span className="text-slate-900 dark:text-slate-300 font-medium whitespace-nowrap">{startIndex + i + 1}.</span>
                          </td>
                          <td className="px-3 py-1.5 whitespace-nowrap text-sm">
                            <span className="font-semibold text-amber-900 dark:text-amber-400 bg-amber-100/70 dark:bg-amber-950/60 px-2 py-0.5 rounded border border-amber-200 dark:border-amber-800/60 font-mono text-xs">
                              {trx.kode_trx || '-'}
                            </span>
                          </td>
                          <td className="px-3 py-1.5 whitespace-nowrap text-sm">
                            <span className="text-amber-700 dark:text-amber-500 font-medium">{trx.jenis_kategori?.nama_jenis}</span>
                            {trx.is_refund === true && (
                              <span className="text-rose-600 dark:text-rose-400 text-[11px] font-bold ml-2 px-2 py-0.5 bg-rose-100/80 dark:bg-rose-950/60 rounded-md border border-rose-300 dark:border-rose-800 inline-flex items-center">
                                Dibatalkan (Refund)
                              </span>
                            )}
                          </td>
                          <td className="px-3 py-1.5 text-sm">
                            <span className="text-slate-800 dark:text-slate-300 font-medium whitespace-nowrap">{trx.user?.cabang?.nama_cabang || '-'}</span>
                          </td>
                          <td className="px-3 py-1.5 text-sm">
                            <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">{trx.kondisi_barang}</span>
                          </td>
                          <td className="px-3 py-1.5 text-sm">
                            <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">
                              <span className="font-medium">{trx.berat} gr</span> <span className="text-slate-400 dark:text-slate-500">| {trx.karat} krt</span>
                            </span>
                          </td>
                          <td className="px-3 py-1.5 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300 font-medium">
                            <span>
                              Rp {numberWithCommas(trx.total_harga === undefined ? '0' : trx.total_harga)}
                            </span>
                          </td>
                          <td className="px-3 py-1.5 text-sm">
                            <span className="whitespace-nowrap text-slate-800 dark:text-slate-300">
                              Rp{' '}
                              {numberWithCommas(
                                trx.total_harga === undefined ? '0' : Math.round(trx.total_harga / trx.berat),
                              )}{' '}
                              <span className="text-slate-400 dark:text-slate-500">/ gr</span>
                            </span>
                          </td>
                          <td className="px-3 py-1.5 text-sm">
                            <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">{trx.created_at}</span>
                          </td>
                          {activeTab === 'Pembelian Return' && (
                            <>
                              <td className="px-3 py-1.5 text-sm">
                                <span className="text-slate-800 dark:text-slate-300 font-medium whitespace-nowrap">{trx.karyawan?.nama_karyawan || '-'}</span>
                              </td>
                              <td className="px-3 py-1.5 text-sm">
                                <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">{trx.updated_at || '-'}</span>
                              </td>
                            </>
                          )}
                          {activeTab !== 'Pembelian Return' && (
                            <td className="px-3 py-1.5 flex items-center justify-center gap-2 text-sm">
                              {trx.is_refund === true ? (
                                <span className="text-[11px] font-bold text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/40 px-2.5 py-1 rounded-lg border border-rose-200 dark:border-rose-900/40">
                                  Sudah Refund
                                </span>
                              ) : trx.status_pengajuan_hapus === 'pending' ? (
                                <span className="text-[11px] font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40 px-2 py-1 rounded-md border border-amber-200 dark:border-amber-900/50">
                                  Menunggu Verifikasi
                                </span>
                              ) : (
                                <Tooltip title="Hapus Pembelian (Refund)">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      getIdDelete(trx.id);
                                    }}
                                    className="w-8 h-8 flex items-center justify-center rounded-md bg-red-500 text-white hover:bg-red-600 shadow-sm transition-colors text-xs focus:outline-none cursor-pointer"
                                  >
                                    <IconTrash size={18} stroke={2} />
                                  </button>
                                </Tooltip>
                              )}
                            </td>
                          )}
                        </tr>
                      ))}
                      <tr className="bg-amber-50/50 dark:bg-slate-800/50 font-bold border-t-2 border-amber-200 dark:border-slate-700 text-slate-800 dark:text-slate-300">
                        <td colSpan={5} className="px-3 py-1.5 text-right">Total Berat Halaman Ini:</td>
                        <td className="px-3 py-1.5 whitespace-nowrap">{trxPembelian.reduce((sum, trx) => sum + Number(trx.berat || 0), 0).toFixed(2)} gr</td>
                        <td colSpan={activeTab === 'Pembelian Return' ? 5 : 4}></td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
              <div className="bg-slate-50 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 py-3 transition-colors">
                <div className="flex justify-between items-center w-full px-5">
                  <div className="flex items-center space-x-2 text-sm text-slate-700 dark:text-slate-300">
                    <span>Tampilkan</span>
                    <select
                      value={perPage}
                      onChange={(e) => {
                        setPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      className="border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 rounded-md px-2 py-1 text-sm focus:outline-none focus:border-amber-500"
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <span>data</span>
                  </div>
                  <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 sm:flex">
                    <span className="block text-slate-700 dark:text-slate-300 font-medium whitespace-nowrap">
                      Halaman
                      <input
                        type="text"
                        value={pageInput}
                        onChange={handlePageInputChange}
                        onBlur={jumpToPage}
                        onKeyDown={handlePageInputKeyDown}
                        className="w-12 h-7 mx-1.5 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-500 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                      />
                      dari <span className="font-bold text-amber-700 dark:text-amber-500">{lastPage}</span>
                    </span>
                    <div className="space-x-1">
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        title="previous"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronLeft className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        title="next"
                        type="button"
                        className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                      >
                        <IconChevronRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default TrxPembelianV2;
